import React from 'react'
import InvoiceProduct from '../component/InvoiceProduct'

export default function ProductInvoice() {
  return (
<InvoiceProduct/>
  )
}
